import React from "react";

const ConditionDescriptions = ({ content }) => {
  return (
    <div className="w-full max-w-[792px] flex flex-col gap-10">
      {content.map((item) => (
        <div className="">
          <h4 className="text-2xl text-darkBlue lg:text-darkGray font-bold mb-4">
            {item.section}
          </h4>
          {item.note && (
            <p className="text-[#FF0000] text-base">{item.note}</p>
          )}
          {item.definition && (
            <p className="mb-3 text-darkGray/80 text-xl whitespace-pre-line">{item.definition}</p>
          )}
          {item.content &&
            item.content.map((desc) => (
              <p className="mb-4 text-darkGray/80 text-xl whitespace-pre-line">{desc}</p>
            ))}
          {item.numericPoints && (
            <ol className="list-decimal text-darkGray/80 text-xl pl-5">
              {item.numericPoints.map((point, index) => (
                <li key={index} className="mb-4">
                  <p className="text-darkGray/80 text-xl">{point}</p>
                </li>
              ))}
            </ol>
          )}
          {item.headingDescription && (
              item.headingDescription.map((point, index) => (
                <div className="flex flex-col text-darkGray/80 pl-1 text-xl mb-4">
                  <p className="mb-2">{index+1}. {point.name}</p>
                  <p className="pl-5">{point.description}</p>
                </div>
              ))
          )}
          {item.bulletPoints && (
            <ul className="list-disc text-xl text-darkGray/80 pl-5">
              {item.bulletPoints.map((point, index) => (
                <li key={index} className="mb-4">
                  <p>{point}</p>
                </li>
              ))}
            </ul>
          )}
          {item.content2 && item.content2.map((desc) => (
            <p className="text-darkGray/80 text-xl mb-4">{desc}</p>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ConditionDescriptions;
